import React from 'react';
import useDfpSlot from './useDfpSlot';

// import { DFPSlotsProvider, AdSlot } from 'react-dfp';

function HomepageAd (){
  useDfpSlot({
    path: '/6674/stuff.wholetruth',
    id: 'div-gpt-ad-8564960-100',
  });
  return (
<div className='ads-wrap-container'>
  <div id="div-gpt-ad-8564960-100">
    
  </div>
  </div>
  )
}

export default HomepageAd;